/**
 * Footer「Featured Products」欄位的排序規則
 * WEDA 固定置頂，其餘依 Dropdown 中 Featured Product 的順序補滿 5 筆
 *
 * @param products: Featured Products 分類下所有產品（依 Dropdown 順序）
 * @param options: { wedaPath: WEDA 產品路徑, isPinWeda: 是否置頂 WEDA, limit: 總筆數 }
 * @returns { name, url }[]
 */

interface IProductItem {
  name: string;
  link: { url: string } | null;
}

interface IOptions {
  wedaPath: string;
  isPinWeda: boolean;
  limit: number;
}

export function provideFooterProducts(
  products: IProductItem[],
  { wedaPath, isPinWeda, limit }: IOptions
): { name: string; url: string }[] {
  const pinned = isPinWeda ? [{ name: 'WEDA', url: wedaPath }] : [];

  const rest = products
    .filter(({ link }) => !link?.url.endsWith(wedaPath))
    .slice(0, limit - pinned.length)
    .map(({ name, link }) => ({ name, url: link?.url ?? 'javascript:;' }));

  return [...pinned, ...rest];
}
